// src/features/auth/components/RutaProtegida.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { obtenerUsuario, hasAllPerms, getCachedMe, wasJustLoggedIn } from "../services/authServices";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

const ShellLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
    <CircularProgress />
  </Box>
);

const RutaProtegida = ({ children, allowedRoles, requiredPerms }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => getCachedMe());
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let alive = true;

    (async () => {
      // si recién se logueó, damos un respiro para evitar rebote
      if (wasJustLoggedIn()) {
        await new Promise(r => setTimeout(r, 300));
      }

      const u = await obtenerUsuario({ useCacheFirst: false });
      if (!alive) return;

      if (!u || !(u.nombre || u.correo)) {
        setChecking(false);
        navigate("/login-erp", { replace: true });
        return;
      }

      if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
        if (!allowedRoles.includes(u.rol)) {
          setChecking(false);
          navigate("/dashboard", { replace: true });
          return;
        }
      }

      if (Array.isArray(requiredPerms) && requiredPerms.length > 0) {
        if (!hasAllPerms(u, requiredPerms)) {
          setChecking(false);
          navigate("/dashboard", { replace: true });
          return;
        }
      }

      setUser(u);
      setChecking(false);
    })();

    return () => { alive = false; };
  }, [navigate, allowedRoles, requiredPerms]);

  if (checking && !user) return <ShellLoader />;
  return children;
};

RutaProtegida.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  requiredPerms: PropTypes.arrayOf(PropTypes.string),
};

export default RutaProtegida;
